import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface MovieCardProps {
  id: string;
  title: string;
  titleEn: string;
  category: string;
  year: number;
  rating: number;
  posterImage: string;
}

export default function MovieCard({ id, title, titleEn, category, year, rating, posterImage }: MovieCardProps) {
  const catInfo = categories.find((c) => c.slug === category);

  return (
    <Link
      to={`/article/article-00${parseInt(id.split('-')[1])}`}
      className="group block"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      <div className="relative overflow-hidden rounded-lg aspect-[2/3] bg-background-200 mb-3">
        <img
          src={posterImage}
          alt={`${title} 电影海报`}
          title={`${title} - 蜜桃电影推荐`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        <div className="absolute top-2 right-2 bg-primary-500 text-background-50 dark:text-foreground-950 text-xs font-bold px-2 py-1 rounded-md">
          {rating}
        </div>
      </div>
      <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base group-hover:text-primary-500 transition-colors truncate">
        {title}
      </h3>
      <p className="text-xs text-foreground-500 mt-1">{titleEn}</p>
      <div className="flex items-center gap-2 mt-1.5">
        {catInfo && (
          <span className="text-xs bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded-full">
            {catInfo.name}
          </span>
        )}
        <span className="text-xs text-foreground-400">{year}</span>
      </div>
    </Link>
  );
}